import React, { useState, useEffect, useRef } from 'react';
import './RotatingWord.css';

const getRandomGradient = () => {
  const gradients = [
    'linear-gradient(45deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(45deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(45deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(45deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(45deg, #a8edea 0%, #fed6e3 100%)',
    'linear-gradient(45deg, #ffecd2 0%, #fcb69f 100%)',
    'linear-gradient(45deg, #ff9a9e 0%, #fecfef 100%)',
    'linear-gradient(45deg, #ffd89b 0%, #19547b 100%)',
    'linear-gradient(45deg, #c471f5 0%, #fa71cd 100%)'
  ];
  return gradients[Math.floor(Math.random() * gradients.length)];
};

const RotatingWord = ({ words, displayTime = 750, transitionTime = 500 }) => {
  const [displayedWords, setDisplayedWords] = useState([words[0]]);
  const [gradientsMap, setGradientsMap] = useState({ 0: getRandomGradient() });
  const [index, setIndex] = useState(0);
  const [maxWidth, setMaxWidth] = useState(0);

  const wordIndexRef = useRef(1); // cycling through words[]
  const wordCountRef = useRef(1); // actual # of words shown so far
  const measureRef = useRef(null);

  // Measure the width of all words to prevent layout shifts
  useEffect(() => {
    if (measureRef.current) {
      let maxWordWidth = 0;
      
      words.forEach(word => {
        const tempElement = document.createElement('div');
        tempElement.style.visibility = 'hidden';
        tempElement.style.position = 'absolute';
        tempElement.style.fontSize = 'inherit';
        tempElement.style.fontFamily = 'inherit';
        tempElement.style.fontWeight = 'inherit';
        tempElement.textContent = word;
        measureRef.current.appendChild(tempElement);
        maxWordWidth = Math.max(maxWordWidth, tempElement.offsetWidth);
        measureRef.current.removeChild(tempElement);
      });
      
      setMaxWidth(maxWordWidth);
    }
  }, [words]);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextWord = words[wordIndexRef.current % words.length];
      const nextIndex = wordCountRef.current;

      setDisplayedWords(prev => [...prev, nextWord]);
      setGradientsMap(prev => ({
        ...prev,
        [nextIndex]: getRandomGradient(),
      }));

      setIndex(prev => prev + 1);
      wordIndexRef.current += 1;
      wordCountRef.current += 1;
    }, displayTime + transitionTime);

    return () => clearInterval(interval);
  }, [words, displayTime, transitionTime]);

  return (
    <div className="rotating-word-container">
      <div 
        className="rotating-word-wrapper"
        style={{ 
          minWidth: `${maxWidth}px`,
          height: '1.2em' // Reserve consistent height
        }}
      >
        <div
          className="rotating-word-inner"
          style={{
            transform: `translateY(-${index * 1.2}em)`,
          }}
        >
          {displayedWords.map((word, i) => (
            <div
              className="rotating-word"
              key={i}
              style={{
                backgroundImage: gradientsMap[i],
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                transition: 'background-image 0.5s ease-in-out',
                height: '1.2em',
                lineHeight: '1.2em'
              }}
            >
              {word}
            </div>
          ))}
        </div>
      </div>
      {/* Hidden element for measuring */}
      <div 
        ref={measureRef} 
        style={{ 
          position: 'absolute', 
          visibility: 'hidden',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          fontWeight: 'inherit'
        }} 
      />
    </div>
  );
};

export default RotatingWord;
